export const RECAPTCHA_SITE_KEY = "6LdmVaQUAAAAAG6UopZLCsaEyrixslDl9c3QvFvz";
